"use client";
import { jsxs as n, jsx as e } from "react/jsx-runtime";
import { withCmsDataHandling as c } from "../../../handlers/withCmsDataHandling/withCmsDataHandling.js";
import p from "../../layout/Container/Container.js";
import { Heading as u, sharedHandler as d } from "@ingeniorforeningen/figurine-core";
import { forwardRef as f } from "react";
import { calculationTableDeliveryApiParser as b } from "./Tables.helpers.js";
import T from "./variants/Tables3Columns.js";
import h from "./variants/TablesCalculation.js";
import C from "./variants/TablesContact.js";
import x from "./variants/TablesTicket.js";
const a = f((i, t) => {
  const { variant: o = "calculation", header: s, items: r, ...m } = i;
  return /* @__PURE__ */ n(p, { size: ((l) => {
    switch (l) {
      case "ticket":
        return "sm";
      default:
        return "mdx";
    }
  })(o), ...m, children: [
    s && /* @__PURE__ */ e(u, { type: "h2", text: s, mt: "xs", mb: "lg" }),
    (() => {
      switch (o) {
        case "ticket":
          return /* @__PURE__ */ e(x, { items: r, ref: t });
        case "contact":
          return /* @__PURE__ */ e(C, { items: r, ref: t });
        case "3Columns":
          return /* @__PURE__ */ e(T, { items: r, ref: t });
        default:
          return /* @__PURE__ */ e(h, { items: r, ref: t });
      }
    })()
  ] });
});
a.displayName = "Tables";
const y = c({
  Component: d(a),
  deliveryApiParser: b
});
y.displayName = a.displayName;
export {
  a as _Tables,
  y as default
};
